import axios from 'axios';
import store from '../store';
import Defaults from './Defaults';
import { getLocale } from './i18n';

/* Her bileşende header nesnesini elle kurmak yerine tek instance.
   Token yenilendiğinde tek yer değişiyor. */
const api = axios.create({
    baseURL: Defaults.applications().backEnd.url + '/api',
    timeout: 30000
});

// İmza, doğrulama ve davet görüntüleme oturum istemez: bunları kullanan
// kişinin sistemde henüz hesabı olmayabilir. Cevap ne olursa olsun logOut
// tetiklenmemeli — giriş yapmamış birini "oturumun sonlandı" diye
// karşılamak anlamsız.
// İki ayrı karar, bilerek iki ayrı fonksiyon. Tek fonksiyonla yönetmek
// hataya yol açtı: davet sayfası "genel" sayılınca daveti kabul etme
// isteği de oturum başlığı olmadan gidiyordu.

// 1) Oturum kapatılsın mı? Genel sayfalarda asla. Ziyaretçinin hesabı hiç
//    olmayabilir; "oturumun sonlandı" demek hem yanlış hem çıkışsız.
function onPublicPage() {
    return /^#\/(sign|davet|join|dogrula|verify)(\/|$)/.test(window.location.hash || '');
}

// 2) İstek oturum gerektirmiyor mu? Yalnızca gerçekten açık olan uçlar.
//    Bu liste başlık göndermeyi değil, cevabı nasıl yorumlayacağımızı belirler.
function isPublicEndpoint(config) {
    const url = config.url || '';
    if (/^\/(sign|verify)(\/|$)/.test(url)) return true;

    // Daveti GÖRÜNTÜLEMEK açık, KABUL ETMEK oturum istiyor:
    // /invitations/<token> açık, /invitations/<token>/accept değil.
    const method = String(config.method || 'get').toLowerCase();
    if (method === 'get' && /^\/invitations\/[^/]+$/.test(url)) return true;

    return false;
}

api.interceptors.request.use(function (config) {
    const app = store.state.the_app_data || {};
    // Oturum varsa başlıklar her isteğe eklenir. Açık uçlar bunları yok
    // sayar; ama daveti kabul etmek gibi oturumlu uçlar aynı sayfadan
    // çağrıldığında başlıksız kalmamalı.
    if (app.token) {
        config.headers['doclock-token'] = app.token;
        config.headers['userid'] = app.userId;
        config.headers['vdate'] = app.valid;
        config.headers['email'] = app.the_user ? app.the_user.email : '';
    }
    config.headers['env'] = Defaults.detectBrowser();
    // Sunucu mesajları kullanıcının o an ekranda gördüğü dilde gelsin.
    // Tarayıcının kendi dili farklı olabilir; arayüzde seçilen dil esas.
    config.headers['Accept-Language'] = getLocale() || 'tr';
    return config;
});

api.interceptors.response.use(
    function (response) {
        // Dosya indirmelerinde gövde JSON değil, bir Blob.
        // Zarf kontrolü uygulanırsa 'code' bulunamaz ve oturum boşuna kapanır.
        const responseType = response.config.responseType;
        if (responseType === 'blob' || responseType === 'arraybuffer') {
            return response.data;
        }

        const body = response.data || {};

        if (isPublicEndpoint(response.config)) {
            if (body.code === 100) return body;
            return Promise.reject(makeError(
                body.message || 'İmza linki doğrulanamadı. Sunucu beklenmeyen bir cevap döndü.'
            ));
        }

        // Bilinmeyen kod = oturum artık geçerli değil
        if (body.code !== 100 && body.code !== 200) {
            if (!onPublicPage()) store.dispatch('logOut');
            return Promise.reject(makeError('Oturumun sonlandı, tekrar giriş yap.'));
        }
        // 200 = iş kuralı hatası, ekranda gösterilecek
        if (body.code === 200) {
            return Promise.reject(makeError(body.message || 'İşlem tamamlanamadı.'));
        }
        return body;
    },
    function (error) {
        // error.response'u kontrol etmeden okumak, ağ koptuğunda uygulamayı çökertiyordu
        if (!error.response) {
            return Promise.reject(makeError('Sunucuya ulaşılamadı. Bağlantını kontrol et.'));
        }
        const status = error.response.status;
        const data = error.response.data;

        // İmza sayfası ziyaretçisi bizim oturumumuzu kapatamamalı
        if (isPublicEndpoint(error.config || {})) {
            if (status === 401 || status === 403) {
                return Promise.reject(makeError(
                    'İmza bağlantısı sunucuda oturum kontrolüne takıldı. ' +
                    '/api/sign yolları auth middleware dışında bırakılmalı.'
                ));
            }
            const publicMessage = data && data.message ? data.message : 'İmza linki açılamadı.';
            return Promise.reject(makeError(
                typeof publicMessage === 'string' ? publicMessage : 'İmza linki açılamadı.'
            ));
        }

        if (status === 429) {
            return Promise.reject(makeError(
                typeof data === 'string' ? data : 'Çok fazla istek gönderdin, biraz bekle.',
                { rateLimit: true }
            ));
        }
        if (status === 401 || status === 403) {
            if (!onPublicPage()) store.dispatch('logOut');
            return Promise.reject(makeError('Oturumun sonlandı, tekrar giriş yap.'));
        }
        const message = data && data.message ? data.message : 'Beklenmeyen bir hata oluştu.';
        return Promise.reject(makeError(typeof message === 'string' ? message : JSON.stringify(message)));
    }
);

function makeError(message, extra) {
    const err = new Error(message);
    return Object.assign(err, extra || {});
}

export default api;


// WEBPACK FOOTER //
// ./src/config/api.js